import image from "../assets/media/images/worldmap-with-server-nodes 1.png";

export const darkColors = [
  //--- C340 Identity G10 ---

  //--- filled G10a ---

  {
    background: "#FF8DB3",
    color: "#7B0040",
    border: "#ED468C",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category11a",
    group: "11a",
  },
  {
    background: "#ED468C",
    color: "#5C002E",
    border: "#B91765",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category12a",
    group: "12a",
  },
  {
    background: "#B91765",
    color: "#FF8DB3",
    border: "#7B0040",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category13a",
    group: "13a",
  },
  {
    background: "#7B0040",
    color: "#FF65A0",
    border: "#3F001D",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category14a",
    group: "14a",
  },
  {
    background: "#7B0040",
    color: "#FF65A0",
    border: "#3F001D",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category15a",
    group: "15a",
  },
  {
    background: "#7B0040",
    color: "#FF65A0",
    border: "#3F001D",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category16a",
    group: "16a",
  },
  {
    background: "#7B0040",
    color: "#FF65A0",
    border: "#3F001D",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category17a",
    group: "17a",
  },
  {
    background: "#7B0040",
    color: "#FF65A0",
    border: "#3F001D",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category18a",
    group: "18a",
  },

  //--- empty G10b ---

  {
    background: "#101119",
    color: "#9C0052",
    border: "#5C002E",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category11b",
    group: "11b",
  },
  {
    background: "#101119",
    color: "#9C0052",
    border: "#5C002E",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category12b",
    group: "12b",
  },
  {
    background: "#101119",
    color: "#9C0052",
    border: "#5C002E",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category13b",
    group: "13b",
  },
  {
    background: "#101119",
    color: "#9C0052",
    border: "#5C002E",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category14b",
    group: "14b",
  },
  {
    background: "#101119",
    color: "#9C0052",
    border: "#5C002E",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category15b",
    group: "15b",
  },
  {
    background: "#101119",
    color: "#9C0052",
    border: "#5C002E",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category16b",
    group: "16b",
  },
  {
    background: "#101119",
    color: "#9C0052",
    border: "#5C002E",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category17b",
    group: "17b",
  },
  {
    background: "#101119",
    color: "#9C0052",
    border: "#5C002E",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category18b",
    group: "18b",
  },

  //--- C020 Health G20 ---

  //--- filled G20a ---

  {
    background: "#FF9661",
    color: "#6A2800",
    border: "#E35F00",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category21a",
    group: "21a",
  },
  {
    background: "#E35F00",
    color: "#4E1C00",
    border: "#A44300",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category22a",
    group: "22a",
  },
  {
    background: "#A44300",
    color: "#FF9661",
    border: "#6A2800",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category23a",
    group: "23a",
  },
  {
    background: "#6A2800",
    color: "#FF721B",
    border: "#351000",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category24a",
    group: "24a",
  },
  {
    background: "#6A2800",
    color: "#FF721B",
    border: "#351000",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category25a",
    group: "25a",
  },
  {
    background: "#6A2800",
    color: "#FF721B",
    border: "#351000",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category26a",
    group: "26a",
  },
  {
    background: "#6A2800",
    color: "#FF721B",
    border: "#351000",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category27a",
    group: "27a",
  },
  {
    background: "#6A2800",
    color: "#FF721B",
    border: "#351000",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category28a",
    group: "28a",
  },

  //--- empty G20b ---

  {
    background: "#101119",
    color: "#873500",
    border: "#4E1C00",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category21b",
    group: "21b",
  },
  {
    background: "#101119",
    color: "#873500",
    border: "#4E1C00",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category22b",
    group: "22b",
  },
  {
    background: "#101119",
    color: "#873500",
    border: "#4E1C00",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category23b",
    group: "23b",
  },
  {
    background: "#101119",
    color: "#873500",
    border: "#4E1C00",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category24b",
    group: "24b",
  },
  {
    background: "#101119",
    color: "#873500",
    border: "#4E1C00",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category25b",
    group: "25b",
  },
  {
    background: "#101119",
    color: "#873500",
    border: "#4E1C00",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category26b",
    group: "26b",
  },
  {
    background: "#101119",
    color: "#873500",
    border: "#4E1C00",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category27b",
    group: "27b",
  },
  {
    background: "#101119",
    color: "#873500",
    border: "#4E1C00",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category28b",
    group: "28b",
  },

  //--- C050 Files G90 ---

  //--- filled G90a ---

  {
    background: "#D2AE00",
    color: "#493B00",
    border: "#A28500",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category91a",
    group: "91a",
  },
  {
    background: "#A28500",
    color: "#352B00",
    border: "#745F00",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category92a",
    group: "92a",
  },
  {
    background: "#745F00",
    color: "#D2AE00",
    border: "#493B00",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category93a",
    group: "93a",
  },
  {
    background: "#493B00",
    color: "#BA9900",
    border: "#231B00",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category94a",
    group: "94a",
  },
  {
    background: "#493B00",
    color: "#BA9900",
    border: "#231B00",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category95a",
    group: "95a",
  },
  {
    background: "#493B00",
    color: "#BA9900",
    border: "#231B00",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category96a",
    group: "96a",
  },
  {
    background: "#493B00",
    color: "#BA9900",
    border: "#231B00",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category97a",
    group: "97a",
  },
  {
    background: "#493B00",
    color: "#BA9900",
    border: "#231B00",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category98a",
    group: "98a",
  },

  //--- empty G90b ---

  {
    background: "#101119",
    color: "#5E4D00",
    border: "#352B00",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category91b",
    group: "91a",
  },
  {
    background: "#101119",
    color: "#5E4D00",
    border: "#352B00",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category92b",
    group: "92a",
  },
  {
    background: "#101119",
    color: "#5E4D00",
    border: "#352B00",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category93b",
    group: "93a",
  },
  {
    background: "#101119",
    color: "#5E4D00",
    border: "#352B00",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category94b",
    group: "94a",
  },
  {
    background: "#101119",
    color: "#5E4D00",
    border: "#352B00",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category95b",
    group: "95a",
  },
  {
    background: "#101119",
    color: "#5E4D00",
    border: "#352B00",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category96b",
    group: "96a",
  },
  {
    background: "#101119",
    color: "#5E4D00",
    border: "#352B00",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category97b",
    group: "97a",
  },
  {
    background: "#101119",
    color: "#5E4D00",
    border: "#352B00",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category98b",
    group: "98a",
  },

  //--- C080 Social G30 ---

  //--- filled G30a ---

  {
    background: "#9FDD0A",
    color: "#324800",
    border: "#78A800",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category31a",
    group: "31a",
  },
  {
    background: "#78A800",
    color: "#223300",
    border: "#547600",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category32a",
    group: "32a",
  },
  {
    background: "#547600",
    color: "#9FDD0A",
    border: "#324800",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category33a",
    group: "33a",
  },
  {
    background: "#324800",
    color: "#8BC200",
    border: "#131F00",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category34a",
    group: "34a",
  },
  {
    background: "#324800",
    color: "#8BC200",
    border: "#131F00",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category35a",
    group: "35a",
  },
  {
    background: "#324800",
    color: "#8BC200",
    border: "#131F00",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category36a",
    group: "36a",
  },
  {
    background: "#324800",
    color: "#8BC200",
    border: "#131F00",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category37a",
    group: "37a",
  },
  {
    background: "#324800",
    color: "#8BC200",
    border: "#131F00",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category38a",
    group: "38a",
  },

  //--- empty G30b ---

  {
    background: "#101119",
    color: "#425F00",
    border: "#223300",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category31b",
    group: "31b",
  },
  {
    background: "#101119",
    color: "#425F00",
    border: "#223300",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category32b",
    group: "32b",
  },
  {
    background: "#101119",
    color: "#425F00",
    border: "#223300",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category33b",
    group: "33b",
  },
  {
    background: "#101119",
    color: "#425F00",
    border: "#223300",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category34b",
    group: "34b",
  },
  {
    background: "#101119",
    color: "#425F00",
    border: "#223300",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category35b",
    group: "35b",
  },
  {
    background: "#101119",
    color: "#425F00",
    border: "#223300",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category36b",
    group: "36b",
  },
  {
    background: "#101119",
    color: "#425F00",
    border: "#223300",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category37b",
    group: "37b",
  },
  {
    background: "#101119",
    color: "#425F00",
    border: "#223300",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category38b",
    group: "38b",
  },

  //--- C120 Location G40 ---

  //--- filled G40a ---

  {
    background: "#56E459",
    color: "#004D0C",
    border: "#0CB12B",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category41a",
    group: "41a",
  },
  {
    background: "#0CB12B",
    color: "#003606",
    border: "#007D1A",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category42a",
    group: "42a",
  },
  {
    background: "#007D1A",
    color: "#56E459",
    border: "#004D0C",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category43a",
    group: "43a",
  },
  {
    background: "#004D0C",
    color: "#38CA42",
    border: "#002103",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category44a",
    group: "44a",
  },
  {
    background: "#004D0C",
    color: "#38CA42",
    border: "#002103",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category45a",
    group: "45a",
  },
  {
    background: "#004D0C",
    color: "#38CA42",
    border: "#002103",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category46a",
    group: "46a",
  },
  {
    background: "#004D0C",
    color: "#38CA42",
    border: "#002103",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category47a",
    group: "47a",
  },
  {
    background: "#004D0C",
    color: "#38CA42",
    border: "#002103",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category48a",
    group: "48a",
  },

  //--- empty G40b ---

  {
    background: "#101119",
    color: "#006513",
    border: "#003606",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category41b",
    group: "41b",
  },
  {
    background: "#101119",
    color: "#006513",
    border: "#003606",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category42b",
    group: "42b",
  },
  {
    background: "#101119",
    color: "#006513",
    border: "#003606",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category43b",
    group: "43b",
  },
  {
    background: "#101119",
    color: "#006513",
    border: "#003606",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category44b",
    group: "44b",
  },
  {
    background: "#101119",
    color: "#006513",
    border: "#003606",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category45b",
    group: "45b",
  },
  {
    background: "#101119",
    color: "#006513",
    border: "#003606",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category46b",
    group: "46b",
  },
  {
    background: "#101119",
    color: "#006513",
    border: "#003606",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category47b",
    group: "47b",
  },
  {
    background: "#101119",
    color: "#006513",
    border: "#003606",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category48b",
    group: "48b",
  },

  //--- C160 Finance G50 ---

  //--- filled G50a ---

  {
    background: "#00E49C",
    color: "#004B30",
    border: "#00AE76",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category51a",
    group: "51a",
  },
  {
    background: "#00AE76",
    color: "#003521",
    border: "#007B52",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category52a",
    group: "52a",
  },
  {
    background: "#007B52",
    color: "#00E49C",
    border: "#004B30",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category53a",
    group: "53a",
  },
  {
    background: "#004B30",
    color: "#00C988",
    border: "#002012",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category54a",
    group: "54a",
  },
  {
    background: "#004B30",
    color: "#00C988",
    border: "#002012",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category55a",
    group: "55a",
  },
  {
    background: "#004B30",
    color: "#00C988",
    border: "#002012",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category56a",
    group: "56a",
  },
  {
    background: "#004B30",
    color: "#00C988",
    border: "#002012",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category57a",
    group: "57a",
  },
  {
    background: "#004B30",
    color: "#00C988",
    border: "#002012",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category58a",
    group: "58a",
  },

  //--- empty G50b ---

  {
    background: "#101119",
    color: "#006241",
    border: "#003521",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category51b",
    group: "51b",
  },
  {
    background: "#101119",
    color: "#006241",
    border: "#003521",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category52b",
    group: "52b",
  },
  {
    background: "#101119",
    color: "#006241",
    border: "#003521",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category53b",
    group: "53b",
  },
  {
    background: "#101119",
    color: "#006241",
    border: "#003521",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category54b",
    group: "54b",
  },
  {
    background: "#101119",
    color: "#006241",
    border: "#003521",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category55b",
    group: "55b",
  },
  {
    background: "#101119",
    color: "#006241",
    border: "#003521",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category56b",
    group: "56b",
  },
  {
    background: "#101119",
    color: "#006241",
    border: "#003521",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category57b",
    group: "57b",
  },
  {
    background: "#101119",
    color: "#006241",
    border: "#003521",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category58b",
    group: "58b",
  },

  //--- C200 Career G60 ---

  //--- filled G60a ---

  {
    background: "#00BEFB",
    color: "#00405D",
    border: "#0091C4",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category61a",
    group: "61a",
  },
  {
    background: "#0091C4",
    color: "#002E45",
    border: "#006790",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category62a",
    group: "62a",
  },
  {
    background: "#006790",
    color: "#00BEFB",
    border: "#00405D",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category63a",
    group: "63a",
  },
  {
    background: "#00405D",
    color: "#00A7DF",
    border: "#001D2E",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category64a",
    group: "64a",
  },
  {
    background: "#00405D",
    color: "#00A7DF",
    border: "#001D2E",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category65a",
    group: "65a",
  },
  {
    background: "#00405D",
    color: "#00A7DF",
    border: "#001D2E",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category66a",
    group: "66a",
  },
  {
    background: "#00405D",
    color: "#00A7DF",
    border: "#001D2E",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category67a",
    group: "67a",
  },
  {
    background: "#00405D",
    color: "#00A7DF",
    border: "#001D2E",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category68a",
    group: "68a",
  },

  //--- empty G60b ---

  {
    background: "#101119",
    color: "#005376",
    border: "#002E45",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category61b",
    group: "61b",
  },
  {
    background: "#101119",
    color: "#005376",
    border: "#002E45",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category62b",
    group: "62b",
  },
  {
    background: "#101119",
    color: "#005376",
    border: "#002E45",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category63b",
    group: "63b",
  },
  {
    background: "#101119",
    color: "#005376",
    border: "#002E45",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category64b",
    group: "64b",
  },
  {
    background: "#101119",
    color: "#005376",
    border: "#002E45",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category65b",
    group: "65b",
  },
  {
    background: "#101119",
    color: "#005376",
    border: "#002E45",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category66b",
    group: "66b",
  },
  {
    background: "#101119",
    color: "#005376",
    border: "#002E45",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category67b",
    group: "67b",
  },
  {
    background: "#101119",
    color: "#005376",
    border: "#002E45",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category68b",
    group: "68b",
  },

  //--- C240 Communication G70 ---

  //--- filled G70a ---

  {
    background: "#A8A9FF",
    color: "#2118A5",
    border: "#7678FF",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category71a",
    group: "71a",
  },
  {
    background: "#7678FF",
    color: "#1C0E81",
    border: "#4C4BDE",
    fontSize: 18,
    fontWeight: 600,
    bubbleSize: 112,
    category: "category72a",
    group: "72a",
  },
  {
    background: "#4C4BDE",
    color: "#A8A9FF",
    border: "#2118A5",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category73a",
    group: "73a",
  },
  {
    background: "#2118A5",
    color: "#8F91FF",
    border: "#130A66",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category74a",
    group: "74a",
  },
  {
    background: "#2118A5",
    color: "#8F91FF",
    border: "#130A66",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category75a",
    group: "75a",
  },
  {
    background: "#2118A5",
    color: "#8F91FF",
    border: "#130A66",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category76a",
    group: "76a",
  },
  {
    background: "#2118A5",
    color: "#8F91FF",
    border: "#130A66",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category77a",
    group: "77a",
  },
  {
    background: "#2118A5",
    color: "#8F91FF",
    border: "#130A66",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category78a",
    group: "78a",
  },

  //--- empty G70b ---

  {
    background: "#101119",
    color: "#3633CD",
    border: "#1C0E81",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category71b",
    group: "71b",
  },
  {
    background: "#101119",
    color: "#3633CD",
    border: "#1C0E81",
    fontSize: 18,
    fontWeight: 600,
    bubbleSize: 112,
    category: "category72b",
    group: "72b",
  },
  {
    background: "#101119",
    color: "#3633CD",
    border: "#1C0E81",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category73b",
    group: "73b",
  },
  {
    background: "#101119",
    color: "#3633CD",
    border: "#1C0E81",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category74b",
    group: "74b",
  },
  {
    background: "#101119",
    color: "#3633CD",
    border: "#1C0E81",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category75b",
    group: "75b",
  },
  {
    background: "#101119",
    color: "#3633CD",
    border: "#1C0E81",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category76b",
    group: "76b",
  },
  {
    background: "#101119",
    color: "#3633CD",
    border: "#1C0E81",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category77b",
    group: "77b",
  },
  {
    background: "#101119",
    color: "#3633CD",
    border: "#1C0E81",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category78b",
    group: "78b",
  },

  //--- c280 Devices G80 ---

  //--- filled G80a ---

  {
    background: "#DD94FF",
    color: "#63008E",
    border: "#C155F7",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category81a",
    group: "81a",
  },
  {
    background: "#C155F7",
    color: "#4A006B",
    border: "#9523CC",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category82a",
    group: "82a",
  },
  {
    background: "#9523CC",
    color: "#DD94FF",
    border: "#63008E",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category83a",
    group: "83a",
  },
  {
    background: "#63008E",
    color: "#D174FF",
    border: "#310049",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category84a",
    group: "84a",
  },
  {
    background: "#63008E",
    color: "#D174FF",
    border: "#310049",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category85a",
    group: "85a",
  },
  {
    background: "#63008E",
    color: "#D174FF",
    border: "#310049",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category86a",
    group: "86a",
  },
  {
    background: "#63008E",
    color: "#D174FF",
    border: "#310049",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category87a",
    group: "87a",
  },
  {
    background: "#63008E",
    color: "#D174FF",
    border: "#310049",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category88a",
    group: "88a",
  },

  //--- empty G80b ---

  {
    background: "#101119",
    color: "#7E00B3",
    border: "#4A006B",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category81b",
    group: "81b",
  },
  {
    background: "#101119",
    color: "#7E00B3",
    border: "#4A006B",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category82b",
    group: "82b",
  },
  {
    background: "#101119",
    color: "#7E00B3",
    border: "#4A006B",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category83b",
    group: "83b",
  },
  {
    background: "#101119",
    color: "#7E00B3",
    border: "#4A006B",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category84b",
    group: "84b",
  },
  {
    background: "#101119",
    color: "#7E00B3",
    border: "#4A006B",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category85b",
    group: "85b",
  },
  {
    background: "#101119",
    color: "#7E00B3",
    border: "#4A006B",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category86b",
    group: "86b",
  },
  {
    background: "#101119",
    color: "#7E00B3",
    border: "#4A006B",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category87b",
    group: "87b",
  },
  {
    background: "#101119",
    color: "#7E00B3",
    border: "#4A006B",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category88b",
    group: "88b",
  },

  //--- C050 Files G90 ---

  {
    background: "#D2AE00",
    color: "#493B00",
    border: "#A28500",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category91a",
    group: "91a",
  },
  {
    background: "#A28500",
    color: "#352B00",
    border: "#745F00",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category92a",
    group: "92a",
  },
  {
    background: "#745F00",
    color: "#D2AE00",
    border: "#493B00",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category93a",
    group: "93a",
  },
  {
    background: "#493B00",
    color: "#BA9900",
    border: "#231B00",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category94a",
    group: "94a",
  },
  {
    background: "#493B00",
    color: "#BA9900",
    border: "#231B00",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category95a",
    group: "95a",
  },
  {
    background: "#493B00",
    color: "#BA9900",
    border: "#231B00",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category96a",
    group: "96a",
  },
  {
    background: "#493B00",
    color: "#BA9900",
    border: "#231B00",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category97a",
    group: "97a",
  },
  {
    background: "#493B00",
    color: "#BA9900",
    border: "#231B00",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category98a",
    group: "98a",
  },

  //--- empty G90 ---
  // background: "#101119",
  // color: "#5E4D00",
  // border: "#352B00",
  //--- C050 Files G90 ---

  {
    background: "#101119",
    color: "#5E4D00",
    border: "#352B00",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category91b",
    group: "91b",
  },
  {
    background: "#101119",
    color: "#5E4D00",
    border: "#352B00",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category92b",
    group: "92b",
  },
  {
    background: "#101119",
    color: "#5E4D00",
    border: "#352B00",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category93b",
    group: "93b",
  },
  {
    background: "#101119",
    color: "#5E4D00",
    border: "#352B00",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category94b",
    group: "94b",
  },
  {
    background: "#101119",
    color: "#5E4D00",
    border: "#352B00",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category95b",
    group: "95b",
  },
  {
    background: "#101119",
    color: "#5E4D00",
    border: "#352B00",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category96b",
    group: "96b",
  },
  {
    background: "#101119",
    color: "#5E4D00",
    border: "#352B00",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category97b",
    group: "97b",
  },
  {
    background: "#101119",
    color: "#5E4D00",
    border: "#352B00",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category98b",
    group: "98b",
  },

  //--- empty G90 ---
  // background: "#101119",
  // color: "#5E4D00",
  // border: "#352B00",
];

export const lightColors = [
  //--- C340 Identity G10 ---

  //--- filled G10a ---

  {
    background: "#9C0052",
    color: "#FFB2C9",
    border: "#D33179",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category11a",
    group: "11a",
  },
  {
    background: "#D33179",
    color: "#FFD1DF",
    border: "#FF65A0",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category12a",
    group: "12a",
  },
  {
    background: "#FF65A0",
    color: "#9C0052",
    border: "#FFB2C9",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category13a",
    group: "13a",
  },
  {
    background: "#FFB2C9",
    color: "#B91765",
    border: "#FFE5ED",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category14a",
    group: "14a",
  },
  {
    background: "#FFB2C9",
    color: "#B91765",
    border: "#FFE5ED",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category15a",
    group: "15a",
  },
  {
    background: "#FFB2C9",
    color: "#B91765",
    border: "#FFE5ED",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category16a",
    group: "16a",
  },
  {
    background: "#FFB2C9",
    color: "#B91765",
    border: "#FFE5ED",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category17a",
    group: "17a",
  },
  {
    background: "#FFB2C9",
    color: "#B91765",
    border: "#FFE5ED",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category18a",
    group: "18a",
  },

  //--- empty G10b ---

  {
    background: "#FCFCFD",
    color: "#FF8DB3",
    border: "#FFD1DF",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category11b",
    group: "11b",
  },
  {
    background: "#FCFCFD",
    color: "#FF8DB3",
    border: "#FFD1DF",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category12b",
    group: "12b",
  },
  {
    background: "#FCFCFD",
    color: "#FF8DB3",
    border: "#FFD1DF",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category13b",
    group: "13b",
  },
  {
    background: "#FCFCFD",
    color: "#FF8DB3",
    border: "#FFD1DF",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category14b",
    group: "14b",
  },
  {
    background: "#FCFCFD",
    color: "#FF8DB3",
    border: "#FFD1DF",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category15b",
    group: "15b",
  },
  {
    background: "#FCFCFD",
    color: "#FF8DB3",
    border: "#FFD1DF",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category16b",
    group: "16b",
  },
  {
    background: "#FCFCFD",
    color: "#FF8DB3",
    border: "#FFD1DF",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category17b",
    group: "17b",
  },
  {
    background: "#FCFCFD",
    color: "#FF8DB3",
    border: "#FFD1DF",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category18b",
    group: "18b",
  },

  //--- C020 Health G20 ---

  //--- filled G20a ---

  {
    background: "#873500",
    color: "#FFB693",
    border: "#C35100",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category21a",
    group: "21a",
  },
  {
    background: "#C35100",
    color: "#FFD6C2",
    border: "#FF721B",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category22a",
    group: "22a",
  },
  {
    background: "#FF721B",
    color: "#873500",
    border: "#FFB693",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category23a",
    group: "23a",
  },
  {
    background: "#FFB693",
    color: "#A44300",
    border: "#FFE7DB",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category24a",
    group: "24a",
  },
  {
    background: "#FFB693",
    color: "#A44300",
    border: "#FFE7DB",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category25a",
    group: "25a",
  },
  {
    background: "#FFB693",
    color: "#A44300",
    border: "#FFE7DB",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category26a",
    group: "26a",
  },
  {
    background: "#FFB693",
    color: "#A44300",
    border: "#FFE7DB",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category27a",
    group: "27a",
  },
  {
    background: "#FFB693",
    color: "#A44300",
    border: "#FFE7DB",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category28a",
    group: "28a",
  },

  //--- empty G20b ---

  {
    background: "#FCFCFD",
    color: "#FF9661",
    border: "#FFD6C2",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category21b",
    group: "21b",
  },
  {
    background: "#FCFCFD",
    color: "#FF9661",
    border: "#FFD6C2",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category22b",
    group: "22b",
  },
  {
    background: "#FCFCFD",
    color: "#FF9661",
    border: "#FFD6C2",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category23b",
    group: "23b",
  },
  {
    background: "#FCFCFD",
    color: "#FF9661",
    border: "#FFD6C2",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category24b",
    group: "24b",
  },
  {
    background: "#FCFCFD",
    color: "#FF9661",
    border: "#FFD6C2",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category25b",
    group: "25b",
  },
  {
    background: "#FCFCFD",
    color: "#FF9661",
    border: "#FFD6C2",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category26b",
    group: "26b",
  },
  {
    background: "#FCFCFD",
    color: "#FF9661",
    border: "#FFD6C2",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category27b",
    group: "27b",
  },
  {
    background: "#FCFCFD",
    color: "#FF9661",
    border: "#FFD6C2",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category28b",
    group: "28b",
  },

  //--- C050 Files G90 ---

  //--- filled G90a ---

  {
    background: "#5E4D00",
    color: "#F3CD16",
    border: "#8B7200",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category91a",
    group: "91a",
  },
  {
    background: "#8B7200",
    color: "#FCE888",
    border: "#BA9900",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category92a",
    group: "92a",
  },
  {
    background: "#BA9900",
    color: "#5E4D00",
    border: "#F3CD16",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category93a",
    group: "93a",
  },
  {
    background: "#F3CD16",
    color: "#745F00",
    border: "#FFF0A8",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category94a",
    group: "94a",
  },
  {
    background: "#F3CD16",
    color: "#745F00",
    border: "#FFF0A8",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category95a",
    group: "95a",
  },
  {
    background: "#F3CD16",
    color: "#745F00",
    border: "#FFF0A8",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category96a",
    group: "96a",
  },
  {
    background: "#F3CD16",
    color: "#745F00",
    border: "#FFF0A8",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category97a",
    group: "97a",
  },
  {
    background: "#F3CD16",
    color: "#745F00",
    border: "#FFF0A8",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category98a",
    group: "98a",
  },

  //--- empty G90b ---

  {
    background: "#FCFCFD",
    color: "#D2AE00",
    border: "#FCE888",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category91b",
    group: "91b",
  },
  {
    background: "#FCFCFD",
    color: "#D2AE00",
    border: "#FCE888",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category92b",
    group: "92b",
  },
  {
    background: "#FCFCFD",
    color: "#D2AE00",
    border: "#FCE888",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category93b",
    group: "93b",
  },
  {
    background: "#FCFCFD",
    color: "#D2AE00",
    border: "#FCE888",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category94b",
    group: "94b",
  },
  {
    background: "#FCFCFD",
    color: "#D2AE00",
    border: "#FCE888",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category95b",
    group: "95b",
  },
  {
    background: "#FCFCFD",
    color: "#D2AE00",
    border: "#FCE888",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category96b",
    group: "96b",
  },
  {
    background: "#FCFCFD",
    color: "#D2AE00",
    border: "#FCE888",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category97b",
    group: "97b",
  },
  {
    background: "#FCFCFD",
    color: "#D2AE00",
    border: "#FCE888",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category98b",
    group: "98b",
  },

  //--- C080 Social G30 ---

  //--- filled G30a ---

  {
    background: "#425F00",
    color: "#B7F732",
    border: "#668F00",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category31a",
    group: "31a",
  },
  {
    background: "#668F00",
    color: "#D3FC7E",
    border: "#8BC200",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category32a",
    group: "32a",
  },
  {
    background: "#8BC200",
    color: "#425F00",
    border: "#B7F732",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category33a",
    group: "33a",
  },
  {
    background: "#B7F732",
    color: "#547600",
    border: "#E1FEA5",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category34a",
    group: "34a",
  },
  {
    background: "#B7F732",
    color: "#547600",
    border: "#E1FEA5",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category35a",
    group: "35a",
  },
  {
    background: "#B7F732",
    color: "#547600",
    border: "#E1FEA5",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category36a",
    group: "36a",
  },
  {
    background: "#B7F732",
    color: "#547600",
    border: "#E1FEA5",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category37a",
    group: "37a",
  },
  {
    background: "#B7F732",
    color: "#547600",
    border: "#E1FEA5",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category38a",
    group: "38a",
  },

  //--- empty G30b ---

  {
    background: "#FCFCFD",
    color: "#9FDD0A",
    border: "#D3FC7E",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category31b",
    group: "31b",
  },
  {
    background: "#FCFCFD",
    color: "#9FDD0A",
    border: "#D3FC7E",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category32b",
    group: "32b",
  },
  {
    background: "#FCFCFD",
    color: "#9FDD0A",
    border: "#D3FC7E",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category33b",
    group: "33b",
  },
  {
    background: "#FCFCFD",
    color: "#9FDD0A",
    border: "#D3FC7E",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category34b",
    group: "34b",
  },
  {
    background: "#FCFCFD",
    color: "#9FDD0A",
    border: "#D3FC7E",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category35b",
    group: "35b",
  },
  {
    background: "#FCFCFD",
    color: "#9FDD0A",
    border: "#D3FC7E",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category36b",
    group: "36b",
  },
  {
    background: "#FCFCFD",
    color: "#9FDD0A",
    border: "#D3FC7E",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category37b",
    group: "37b",
  },
  {
    background: "#FCFCFD",
    color: "#9FDD0A",
    border: "#D3FC7E",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category38b",
    group: "38b",
  },

  //--- C120 Location G40 ---

  //--- filled G40a ---

  {
    background: "#006513",
    color: "#77F875",
    border: "#009722",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category41a",
    group: "41a",
  },
  {
    background: "#009722",
    color: "#A7FDA5",
    border: "#38CA42",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category42a",
    group: "42a",
  },
  {
    background: "#38CA42",
    color: "#006513",
    border: "#77F875",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category43a",
    group: "43a",
  },
  {
    background: "#77F875",
    color: "#007D1A",
    border: "#CDFFCC",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category44a",
    group: "44a",
  },
  {
    background: "#77F875",
    color: "#007D1A",
    border: "#CDFFCC",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category45a",
    group: "45a",
  },
  {
    background: "#77F875",
    color: "#007D1A",
    border: "#CDFFCC",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category46a",
    group: "46a",
  },
  {
    background: "#77F875",
    color: "#007D1A",
    border: "#CDFFCC",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category47a",
    group: "47a",
  },
  {
    background: "#77F875",
    color: "#007D1A",
    border: "#CDFFCC",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category48a",
    group: "48a",
  },

  //--- empty G40b ---

  {
    background: "#FCFCFD",
    color: "#56E459",
    border: "#A7FDA5",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category41b",
    group: "41b",
  },
  {
    background: "#FCFCFD",
    color: "#56E459",
    border: "#A7FDA5",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category42b",
    group: "42b",
  },
  {
    background: "#FCFCFD",
    color: "#56E459",
    border: "#A7FDA5",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category43b",
    group: "43b",
  },
  {
    background: "#FCFCFD",
    color: "#56E459",
    border: "#A7FDA5",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category44b",
    group: "44b",
  },
  {
    background: "#FCFCFD",
    color: "#56E459",
    border: "#A7FDA5",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category45b",
    group: "45b",
  },
  {
    background: "#FCFCFD",
    color: "#56E459",
    border: "#A7FDA5",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category46b",
    group: "46b",
  },
  {
    background: "#FCFCFD",
    color: "#56E459",
    border: "#A7FDA5",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category47b",
    group: "47b",
  },
  {
    background: "#FCFCFD",
    color: "#56E459",
    border: "#A7FDA5",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category48b",
    group: "48b",
  },

  //--- C160 Finance G50 ---

  //--- filled G50a ---

  {
    background: "#006241",
    color: "#3AFFB2",
    border: "#009463",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category51a",
    group: "51a",
  },
  {
    background: "#009463",
    color: "#99FFD7",
    border: "#00C988",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category52a",
    group: "52a",
  },
  {
    background: "#00C988",
    color: "#006241",
    border: "#3AFFB2",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category53a",
    group: "53a",
  },
  {
    background: "#3AFFB2",
    color: "#007B52",
    border: "#C7FFE9",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category54a",
    group: "54a",
  },
  {
    background: "#3AFFB2",
    color: "#007B52",
    border: "#C7FFE9",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category55a",
    group: "55a",
  },
  {
    background: "#3AFFB2",
    color: "#007B52",
    border: "#C7FFE9",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category56a",
    group: "56a",
  },
  {
    background: "#3AFFB2",
    color: "#007B52",
    border: "#C7FFE9",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category57a",
    group: "57a",
  },
  {
    background: "#3AFFB2",
    color: "#007B52",
    border: "#C7FFE9",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category58a",
    group: "58a",
  },

  //--- empty G50b ---

  {
    background: "#FCFCFD",
    color: "#00E49C",
    border: "#99FFD7",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category51b",
    group: "51b",
  },
  {
    background: "#FCFCFD",
    color: "#00E49C",
    border: "#99FFD7",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category52b",
    group: "52b",
  },
  {
    background: "#FCFCFD",
    color: "#00E49C",
    border: "#99FFD7",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category53b",
    group: "53b",
  },
  {
    background: "#FCFCFD",
    color: "#00E49C",
    border: "#99FFD7",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category54b",
    group: "54b",
  },
  {
    background: "#FCFCFD",
    color: "#00E49C",
    border: "#99FFD7",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category55b",
    group: "55b",
  },
  {
    background: "#FCFCFD",
    color: "#00E49C",
    border: "#99FFD7",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category56b",
    group: "56b",
  },
  {
    background: "#FCFCFD",
    color: "#00E49C",
    border: "#99FFD7",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category57b",
    group: "57b",
  },
  {
    background: "#FCFCFD",
    color: "#00E49C",
    border: "#99FFD7",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category58b",
    group: "58b",
  },

  //--- c200 Career G60 ---

  //--- filled G60a ---

  {
    background: "#005376",
    color: "#71D1FF",
    border: "#007CAA",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category61a",
    group: "61a",
  },
  {
    background: "#007CAA",
    color: "#A3E1FF",
    border: "#00A7DF",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category62a",
    group: "62a",
  },
  {
    background: "#00A7DF",
    color: "#005376",
    border: "#71D1FF",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category63a",
    group: "63a",
  },
  {
    background: "#71D1FF",
    color: "#006790",
    border: "#CCEEFF",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category64a",
    group: "64a",
  },
  {
    background: "#71D1FF",
    color: "#006790",
    border: "#CCEEFF",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category65a",
    group: "65a",
  },
  {
    background: "#71D1FF",
    color: "#006790",
    border: "#CCEEFF",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category66a",
    group: "66a",
  },
  {
    background: "#71D1FF",
    color: "#006790",
    border: "#CCEEFF",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category67a",
    group: "67a",
  },
  {
    background: "#71D1FF",
    color: "#006790",
    border: "#CCEEFF",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category68a",
    group: "68a",
  },

  //--- empty G60b ---

  {
    background: "#FCFCFD",
    color: "#00BEFB",
    border: "#A3E1FF",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category61b",
    group: "61b",
  },
  {
    background: "#FCFCFD",
    color: "#00BEFB",
    border: "#A3E1FF",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category62b",
    group: "62b",
  },
  {
    background: "#FCFCFD",
    color: "#00BEFB",
    border: "#A3E1FF",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category63b",
    group: "63b",
  },
  {
    background: "#FCFCFD",
    color: "#00BEFB",
    border: "#A3E1FF",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category64b",
    group: "64b",
  },
  {
    background: "#FCFCFD",
    color: "#00BEFB",
    border: "#A3E1FF",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category65b",
    group: "65b",
  },
  {
    background: "#FCFCFD",
    color: "#00BEFB",
    border: "#A3E1FF",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category66b",
    group: "66b",
  },
  {
    background: "#FCFCFD",
    color: "#00BEFB",
    border: "#A3E1FF",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category67b",
    group: "67b",
  },
  {
    background: "#FCFCFD",
    color: "#00BEFB",
    border: "#A3E1FF",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category68b",
    group: "68b",
  },

  //--- C240 Communication G70 ---

  //--- filled G70a ---

  {
    background: "#3633CD",
    color: "#BDBDFF",
    border: "#6061F3",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category71a",
    group: "71a",
  },
  {
    background: "#6061F3",
    color: "#D1D1FF",
    border: "#8F91FF",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category72a",
    group: "72a",
  },
  {
    background: "#8F91FF",
    color: "#3633CD",
    border: "#BDBDFF",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category73a",
    group: "73a",
  },
  {
    background: "#BDBDFF",
    color: "#4C4BDE",
    border: "#E5E5FF",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category74a",
    group: "74a",
  },
  {
    background: "#BDBDFF",
    color: "#4C4BDE",
    border: "#E5E5FF",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category75a",
    group: "75a",
  },
  {
    background: "#BDBDFF",
    color: "#4C4BDE",
    border: "#E5E5FF",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category76a",
    group: "76a",
  },
  {
    background: "#BDBDFF",
    color: "#4C4BDE",
    border: "#E5E5FF",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category77a",
    group: "77a",
  },
  {
    background: "#BDBDFF",
    color: "#4C4BDE",
    border: "#E5E5FF",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category78a",
    group: "78a",
  },

  //--- empty G70b ---

  {
    background: "#FCFCFD",
    color: "#A8A9FF",
    border: "#D1D1FF",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category71b",
    group: "71b",
  },
  {
    background: "#FCFCFD",
    color: "#A8A9FF",
    border: "#D1D1FF",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category72b",
    group: "72b",
  },
  {
    background: "#FCFCFD",
    color: "#A8A9FF",
    border: "#D1D1FF",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category73b",
    group: "73b",
  },
  {
    background: "#FCFCFD",
    color: "#A8A9FF",
    border: "#D1D1FF",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category74b",
    group: "74b",
  },
  {
    background: "#FCFCFD",
    color: "#A8A9FF",
    border: "#D1D1FF",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category75b",
    group: "75b",
  },
  {
    background: "#FCFCFD",
    color: "#A8A9FF",
    border: "#D1D1FF",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category76b",
    group: "76b",
  },
  {
    background: "#FCFCFD",
    color: "#A8A9FF",
    border: "#D1D1FF",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category77b",
    group: "77b",
  },
  {
    background: "#FCFCFD",
    color: "#A8A9FF",
    border: "#D1D1FF",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category78b",
    group: "78b",
  },

  //--- C280 Devices G80 ---

  //--- filled G80a ---

  {
    background: "#7E00B3",
    color: "#E9B8FF",
    border: "#AB3EE1",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category81a",
    group: "81a",
  },
  {
    background: "#AB3EE1",
    color: "#F1D1FF",
    border: "#D174FF",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category82a",
    group: "82a",
  },
  {
    background: "#D174FF",
    color: "#7E00B3",
    border: "#E9B8FF",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category83a",
    group: "83a",
  },
  {
    background: "#E9B8FF",
    color: "#9523CC",
    border: "#F7E5FF",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category84a",
    group: "84a",
  },
  {
    background: "#E9B8FF",
    color: "#9523CC",
    border: "#F7E5FF",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category85a",
    group: "85a",
  },
  {
    background: "#E9B8FF",
    color: "#9523CC",
    border: "#F7E5FF",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category86a",
    group: "86a",
  },
  {
    background: "#E9B8FF",
    color: "#9523CC",
    border: "#F7E5FF",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category87a",
    group: "87a",
  },
  {
    background: "#E9B8FF",
    color: "#9523CC",
    border: "#F7E5FF",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category88a",
    group: "88a",
  },

  //--- empty G80b ---

  {
    background: "#FCFCFD",
    color: "#DD94FF",
    border: "#F1D1FF",
    fontSize: 20,
    fontWeight: 700,
    bubbleSize: 128,
    category: "category81b",
    group: "81b",
  },
  {
    background: "#FCFCFD",
    color: "#DD94FF",
    border: "#F1D1FF",
    fontSize: 18,
    fontWeight: 700,
    bubbleSize: 112,
    category: "category82b",
    group: "82b",
  },
  {
    background: "#FCFCFD",
    color: "#DD94FF",
    border: "#F1D1FF",
    fontSize: 16,
    fontWeight: 600,
    bubbleSize: 96,
    category: "category83b",
    group: "83b",
  },
  {
    background: "#FCFCFD",
    color: "#DD94FF",
    border: "#F1D1FF",
    fontSize: 14,
    fontWeight: 600,
    bubbleSize: 80,
    category: "category84b",
    group: "84b",
  },
  {
    background: "#FCFCFD",
    color: "#DD94FF",
    border: "#F1D1FF",
    fontSize: 12,
    fontWeight: 500,
    bubbleSize: 64,
    category: "category85b",
    group: "85b",
  },
  {
    background: "#FCFCFD",
    color: "#DD94FF",
    border: "#F1D1FF",
    fontSize: 10,
    fontWeight: 500,
    bubbleSize: 48,
    category: "category86b",
    group: "86b",
  },
  {
    background: "#FCFCFD",
    color: "#DD94FF",
    border: "#F1D1FF",
    fontSize: 8,
    fontWeight: 400,
    bubbleSize: 40,
    category: "category87b",
    group: "87b",
  },
  {
    background: "#FCFCFD",
    color: "#DD94FF",
    border: "#F1D1FF",
    fontSize: 6,
    fontWeight: 400,
    bubbleSize: 32,
    category: "category88b",
    group: "88b",
  },
];

export const twinModalParams = {
  location: "Global/EU/US/Asia",
  numberOfNodes: 127,
  image: image,
  maxUserStorage: 500,
  usedStorage: 342,
  filesUploaded: 39247,
  dumpUploads: 3,
  metaDataFiles: 28456,
  taggedFiles: 26892,
  untaggedFiles: 1564,
  lastUploadDate: "2026-01-22",

  categories: {
    1: { name: 'Identity', maxData: 5000, usedData: 4521, unusedData: 479, actRate: 890, tagRate: 920, linkingRate: 780, tierLevel: 94 },
    2: { name: 'Health', maxData: 8000, usedData: 6847, unusedData: 1153, actRate: 780, tagRate: 850, linkingRate: 720, tierLevel: 89 },
    3: { name: 'Social', maxData: 5000, usedData: 3892, unusedData: 1108, actRate: 920, tagRate: 880, linkingRate: 910, tierLevel: 96 },
    4: { name: 'Location', maxData: 10000, usedData: 8234, unusedData: 1766, actRate: 950, tagRate: 920, linkingRate: 870, tierLevel: 92 },
    5: { name: 'Finance', maxData: 7000, usedData: 5643, unusedData: 1357, actRate: 820, tagRate: 900, linkingRate: 850, tierLevel: 91 },
    6: { name: 'Career', maxData: 4000, usedData: 2987, unusedData: 1013, actRate: 750, tagRate: 810, linkingRate: 680, tierLevel: 85 },
    7: { name: 'Communication', maxData: 8000, usedData: 7123, unusedData: 877, actRate: 970, tagRate: 940, linkingRate: 920, tierLevel: 98 },
    8: { name: 'Devices', maxData: 3000, usedData: 156, unusedData: 2844, actRate: 450, tagRate: 520, linkingRate: 380, tierLevel: 42 },
  },

  category: {
    maxData: 10000,
    usedData: 500,
    unusedData: 0,
    actRate: 500,
    tagRate: 500,
    linkingRate: 500,
    tierLevel: 99,
  },
};
